import { render, staticRenderFns } from "./NewAppointmentBtn.vue?vue&type=template&id=7f1d7d6c&scoped=true&"
import script from "./NewAppointmentBtn.vue?vue&type=script&lang=js&"
export * from "./NewAppointmentBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1d7d6c",
  null
  
)

export default component.exports